
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload } from '@/components';
import { useTournamentMedalAdd } from '@/modules/tournament/medal/model/add';
import { ROUTE_NAME_TOURNAMENT } from '@/modules/tournament/router';

export default defineComponent({
    name: ROUTE_NAME_TOURNAMENT.MEDAL.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppFileUpload },
    setup() {
        const { model, v$, create } = useTournamentMedalAdd();

        return { v$, model, create };
    }
});
